import { prop } from 'ramda';

import { clear, unprefix } from '../../../helpers/compact';
import { toImage } from '../fields/image';
import { toText } from '../fields/text';
import { caption } from './caption';

export const image = (data) => {
  const { src, title, desc, ...rest } = unprefix('image', data);
  if (prop('url', src)) {
    return clear({
      ...toImage(src),
      title: toText(title),
      desc: toText(desc),
      caption: caption(rest),
    });
  }
};
